<template>
  <div :class="layoutContainerClass" @click="onDocumentClick">
    <div class="layout-main" :class="{'is-creator-view': isCreator}">
      <AppTopBar
        v-if="isBrand"
        :menuMode="menuMode"
        :colorScheme="colorScheme"
        :menuActive="menuActive"
        :topbarMenuActive="topbarMenuActive"
        :activeInlineProfile="activeInlineProfile"
        @topbar-item-click="onTopbarItemClick"
        @menubutton-click="onMenuButtonClick"
        @sidebar-mouse-over="onSidebarMouseOver"
        @sidebar-mouse-leave="onSidebarMouseLeave"
        @toggle-menu="onToggleMenu"
        @change-inlinemenu="onChangeActiveInlineMenu"
        @menu-click="onMenuClick"
        @menuitem-click="onMenuItemClick"
        @root-menuitem-click="onRootMenuItemClick"
      />

      <div class="p-d-flex layout-main-content-wrapper">
        <div class="layout-main-content">
          <suspense>
            <router-view />
          </suspense>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import AppTopBar from './AppTopbar.vue';
import AppRightMenu from './AppRightMenu.vue';
import AppFooter from './AppFooter.vue';
import AppBreadcrumb from './AppBreadcrumb.vue';
import EventBus from './event-bus';
import CreateShipmentModal from './components/CreateShipmentModal';
import MobileMenu from "./components/MobileMenu";

export default {
  emits: [
    'layout-mode-change',
    'menu-theme',
    'layoutModeChange',
    'sidebar-mouse-over',
    'sidebar-mouse-leave',
    'change-inlinemenu'
  ],
  props: {
    colorScheme: String,
    topbarTheme: String,
    theme: String,
    componentTheme: String
  },
  data() {
    return {
      sideMenu: [
        {
          label: 'My account',
          icon: 'pi pi-fw pi-user',
          to: {name: 'account.settings'}
        },
        {
          label: 'Shipping Address',
          icon: 'pi pi-fw pi-globe',
          to: {name: 'shipping.address'}
        },
        {
          label: 'Payment Settings',
          icon: 'pi pi-fw pi-credit-card',
          to: {name: 'payments.settings'}
        },
        {
          label: 'Brand settings',
          icon: 'pi pi-fw pi-book',
          to: {name: 'brand.settings'}
        },
        {
          label: 'Integrations',
          icon: 'pi pi-fw pi-sliders-h',
          to: {name: 'integrations'}
        },
        {
          label: 'Creative reports',
          icon: 'pi pi-fw pi-sliders-h',
          to: {name: 'creative.reports'}
        },
        {
          label: 'Create shipment',
          icon: 'pi pi-fw pi-sliders-h',
          command: () => {
            this.createShipmentModalVisible = true;
          }
        },
        {
          label: 'Creative creative',
          icon: 'pi pi-fw pi-sliders-h',
          to: {name: 'creative.create'}
        },
        {
          label: 'Team',
          icon: 'pi pi-fw pi-sliders-h',
          to: {name: 'team'}
        },
        {
          label: 'Chat demo',
          icon: 'pi pi-fw pi-sliders-h',
          to: {name: 'chat.demo'}
        },
        {
          label: 'Flow for creators',
          icon: 'pi pi-fw pi-sliders-h',
          to: {name: 'creators.flow'}
        },
      ],
      createShipmentModalVisible: false,
      search: false,
      searchClick: false,
      searchActive: false,
      menuMode: 'horizontal',
      menuActive: false,
      activeInlineProfile: false,
      inlineMenuClick: false,
      overlayMenuActive: false,
      topbarMenuActive: false,
      topbarItemClick: false,
      sidebarActive: false,
      sidebarStatic: false,
      pinActive: false,
      staticMenuDesktopInactive: false,
      staticMenuMobileActive: false,
      rightMenuClick: false,
      rightMenuActive: false,
      configActive: false,
      configClick: false,
    }
  },
  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
    }
  },
  methods: {
    onDocumentClick() {
      if (!this.searchClick && this.searchActive) {
        this.onSearchHide();
      }

      if (!this.topbarItemClick) {
        this.topbarMenuActive = false;
      }

      if (!this.menuClick) {
        if (this.isHorizontal() || this.isSlim()) {
          this.menuActive = false;
          EventBus.emit('reset-active-index');
        }

        if (this.overlayMenuActive || this.staticMenuMobileActive) {
          this.overlayMenuActive = false;
          this.staticMenuMobileActive = false;
        }

        this.hideOverlayMenu();
        this.unblockBodyScroll();
      }

      if (!this.rightMenuClick) {
        this.rightMenuActive = false;
      }

      if (this.configActive && !this.configClick) {
        this.configActive = false;
      }

      this.topbarItemClick = false;
      this.menuClick = false;
      this.configClick = false;
      this.rightMenuClick = false;
      this.searchClick = false;
      this.inlineMenuClick = false;
    },
    onSearchHide() {
      this.searchActive = false;
      this.searchClick = false;
    },
    onSidebarMouseOver() {
      if (this.menuMode === 'sidebar' && !this.sidebarStatic) {
        this.sidebarActive = this.isDesktop();
        setTimeout(() => {
          this.pinActive = this.isDesktop();
        }, 200);
      }
    },
    onSidebarMouseLeave() {
      if (this.menuMode === 'sidebar' && !this.sidebarStatic) {
        setTimeout(() => {
          this.sidebarActive = false;
          this.pinActive = false;
        }, 250);
      }
    },
    hideOverlayMenu() {
      this.overlayMenuActive = false;
      this.staticMenuMobileActive = false;
    },
    onMenuButtonClick(event) {
      this.menuClick = true;

      if (this.isOverlay()) {
        this.overlayMenuActive = !this.overlayMenuActive;
      }

      if (this.isDesktop()) {
        this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
      } else {
        this.staticMenuMobileActive = !this.staticMenuMobileActive;
      }

      event.preventDefault();
    },
    onTopbarItemClick(event) {
      this.topbarItemClick = true;
      this.topbarMenuActive = !this.topbarMenuActive;
      this.hideOverlayMenu();
      event.preventDefault();
    },
    onRightMenuButtonClick() {
      this.rightMenuClick = true;
      this.rightMenuActive = true;
    },
    onRightMenuClick() {
      this.rightMenuClick = true;
    },
    onMenuClick() {
      this.menuClick = true;
    },
    onRootMenuItemClick() {
      this.menuActive = !this.menuActive;
    },
    onMenuItemClick(event) {
      if (!event.item.items) {
        this.hideOverlayMenu();
        EventBus.emit('reset-active-index');
      }

      if (!event.item.items && (this.isHorizontal() || this.isSlim())) {
        this.menuActive = false;
      }
    },
    onToggleMenu(event) {
      this.menuClick = true;

      if (this.overlayMenuActive) {
        this.overlayMenuActive = false;
      }

      if (this.sidebarActive) {
        this.sidebarStatic = !this.sidebarStatic;
      }

      event.preventDefault();
    },
    onChangeActiveInlineMenu() {
      this.activeInlineProfile = !this.activeInlineProfile;
    },
    blockBodyScroll() {
      if (document.body.classList) {
        document.body.classList.add('blocked-scroll');
      } else {
        document.body.className += ' blocked-scroll';
      }
    },
    unblockBodyScroll() {
      if (document.body.classList) {
        document.body.classList.remove('blocked-scroll');
      } else {
        document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
          'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
      }
    },
    isHorizontal() {
      return this.menuMode === 'horizontal';
    },
    isSlim() {
      return this.menuMode === 'slim';
    },
    isOverlay() {
      return this.menuMode === 'overlay';
    },
    isStatic() {
      return this.menuMode === 'static';
    },
    isSidebar() {
      return this.menuMode === 'sidebar';
    },
    isDesktop() {
      return window.innerWidth > 991;
    },
    isMobile() {
      return window.innerWidth <= 991;
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),
    isBrand() {
      return this.user?.roles.find(role => role.title === 'Brand') !== undefined
    },
    isCreator() {
      return this.user?.roles.find(role => role.title === 'Creator') !== undefined
    },
    layoutContainerClass() {
      return [
        'layout-wrapper',
        {
          'layout-static': this.menuMode === 'static',
          'layout-overlay': this.menuMode === 'overlay',
          'layout-overlay-active': this.overlayMenuActive,
          'layout-slim': this.menuMode === 'slim',
          'layout-horizontal': this.menuMode === 'horizontal',
          'layout-active': this.menuActive,
          'layout-mobile-active': this.staticMenuMobileActive,
          'layout-sidebar': this.menuMode === 'sidebar',
          'layout-sidebar-static': this.menuMode === 'sidebar' && this.sidebarStatic,
          'layout-static-inactive': this.staticMenuDesktopInactive && this.menuMode === 'static',
          'p-ripple-disabled': this.$primevue.config.ripple === false
        }
      ];
    }
  },
  components: {
    MobileMenu,
    AppTopBar,
    CreateShipmentModal,
  }
}
</script>

<style lang="scss" scoped>
@import './assets/sass/theme_variables';

.sidebar {
  width: toRem(300);
  padding-top: toRem(30);

  ::v-deep(.p-menu) {
    width: 100%;
    background: none;
    border: none;
  }
}

.layout-main-content-wrapper {
  flex: 1 1 0;
}

.is-creator-view {
  .layout-main-content-wrapper {
    height: calc(100vh - 54px);
    overflow-y: auto;
  }
}
</style>
